"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    Tab: function() {
        return _index.Tab;
    },
    renderTab_unstable: function() {
        return _index.renderTab_unstable;
    },
    tabClassNames: function() {
        return _index.tabClassNames;
    },
    tabReservedSpaceClassNames: function() {
        return _index.tabReservedSpaceClassNames;
    },
    useTabAnimatedIndicatorStyles_unstable: function() {
        return _index.useTabAnimatedIndicatorStyles_unstable;
    },
    useTabButtonStyles_unstable: function() {
        return _index.useTabButtonStyles_unstable;
    },
    useTabContentStyles_unstable: function() {
        return _index.useTabContentStyles_unstable;
    },
    useTabIndicatorStyles_unstable: function() {
        return _index.useTabIndicatorStyles_unstable;
    },
    useTabStyles_unstable: function() {
        return _index.useTabStyles_unstable;
    },
    useTab_unstable: function() {
        return _index.useTab_unstable;
    }
});
const _index = require("./components/Tab/index");
